import VideoCarousel from "../../videoCarousel";
import { ModalGlass } from "../../components/modal";

export default function PartsPage() {
  return (
    <div>
      <div className="relative">
        <div
          className="hero pt-20 h-full w-full"
          style={{
            backgroundImage: `url(https://static.igem.wiki/teams/4260/wiki/imagen/laboratory/fotos-parts/fondo-parts.png)`,
            minHeight: 200,
          }}
        >
          <div>
            <h1 className="text-6xl text-white font-bold text-center">PARTS</h1>
            <VideoCarousel />

            <h1 className="text-6xl text-white font-bold">BIOSENSOR</h1>
            <div>
              <p className="text-white text-lg border-2 rounded-md text-3xl m-20">
                The TecCEM team 2022 designed this sequence for the codification
                of the Human Estrogen Receptor Alpha (hERa), this is a receptor
                protein which aim is to bind to estrogens. This protein keeps
                important aminoacids sites that ensures ligands binding. It is
                also used as the biological receptor of some endocrine
                disrupting chemicals. Therefore, we used the genomic coding
                sequence of Homo sapiens Estrogen Receptor 1 (ESR1) optimizing
                its codons for an E.coli expression added a (GGGGSC) linker,
                this one is composed of four glycines, one rine and one
                cysteine, with the purpose of attaching hER alpha protein to
                chitosan, thus, ensuring the desired position of the molecule
                showing the estrogen binding site up for an effective capture.
                The periplasmic signal eptide element “OmpA” helps the celular
                machinery to speed up the process of protein expression and send
                it to the periplasmic space, where it can be purified using the
                histidine tag for a nickel column.
              </p>
              <p></p>
              <div>
                <p
                  className="text-4xl"
                  style={{
                    color: "yellow",
                  }}
                ></p>
                <div className="text-white text-lg border-2 rounded-md text-3xl m-20">
                  <p>
                    <em style={{ color: "yellow" }}>
                      Improvement of an existing part
                    </em>
                    <br />
                    BBa_K4260001: ESR1 (composite parts)
                  </p>
                  <p style={{ marginTop: "5" }}>T7 promoter BBa_J64997</p>
                  <p>Lac-operator BBa_K1624002</p>
                  <p style={{ marginTop: "5" }}>
                    OmpA_Linker_ESR1_HisTag_ BBa_K4260001
                  </p>
                  <p>
                    Terminador T7 BBa_K395601ESR1 (protein coding) BBa_K4260002
                  </p>
                  <p>BBa_K4260002: ESR1 (protein coding)</p>
                  <p>OmpA_signal peptide [1] [2]</p>
                  <p>
                    lInker(CSGGGG) [3] [4]
                    <br /> ESR1 mRNA sequence [5] <br /> Histidine tag [6]{" "}
                    <br />
                    See our in vitro assembly at parts.
                  </p>
                </div>
              </div>

              <h1 className="text-6xl text-white font-bold">
                BIOSENSOR NEXT PART
              </h1>

              <p className="text-white m-20 border-2 rounded-md text-3xl">
                This part encodes an intein mediated biosensor, consisting of a
                divided AmilCP chromoprotein gene, a mutated intein RecA
                N-terminal and C-terminal domains and a ESR1 Ligand Binding
                Domain. The RecA intein comes from Mycobacterium tuberculosis
                (Mtu) which has been mutated with the purpose of making it more
                stable.
              </p>

              <p className="text-white m-20 border-2 rounded-md text-3xl">
                iGEM TecCEM 2022 Team designed this composite part with coding
                sequence for Laccase from Trametes versicolor, making a
                contribution to the part registered by iGEM12_UCL_London,
                BBa_K729002 , even though that laccase was analyzed to degrade
                polyethylene, but due to being capable of degrading phenolic
                compounds, it is of interest for degrading Endocrine Chemical
                Disruptors, the problematic set for this year competition by our
                team, we aim to oxidize EDCs such as BPA into less aggressive,
                photosensitive removable compounds [1][2]. The chosen biobrick
                has good characterization provided by other teams. Laccase from
                white rot fungi Trametes versicolor with signal peptide OmpA [3]
                [4] and histidine tag (Protein coding) for endocrine disruptor
                chemicals in wastewater is a composite part built to produce
                laccase in the periplasmic space of E.Coli in where proteins are
                better solubilized. The laccase from Trametes Versicolor was
                chosen because its wide range of substrates and its ability to
                carry out its redox reaction in the absence of hydrogen peroxide
                [1][2]. Amino acids were optimized for E.Coli as biofabric,
                because the original sequence comes from Trametes Versicolor. We
                added both a promoter and a terminator sequence to the construct
                in order to allow protein expression using a cloning and
                expression plasmid for bacterial transformation.
              </p>

              <label htmlFor="BiosensorNext">
                <h1 className="text-3xl text-white font-bold text-center">
                  References (Click me!)
                </h1>
              </label>

              <ModalGlass modalId="BiosensorNext">
                <p className="text-white m-20 border-2 rounded-md text-3xl">
                  [1] http://parts.igem.org/Part:BBa_B0010 [2]
                  http://parts.igem.org/Part:BBa_J23100 [3] *link regestry [4]
                  http://parts.igem.org/Part:BBa_B0030 [5]
                  http://parts.igem.org/Part:BBa_J32015 [6] Yamada, M., Okada,
                  Y., Yoshida, T., & Nagasawa, T. (2007). Purification,
                  characterization and gene cloning of isoeugenol-degrading
                  enzyme from Pseudomonas putida IE27. Archives of microbiology,
                  187(6), 511–517. https://doi.org/10.1007/s00203-007-0218-9 [7]
                  *link regestry [8] *link regestry [9] Ryu, J. Y., Seo, J.,
                  Unno, T., Ahn, J. H., Yan, T., Sadowsky, M. J., & Hur, H. G.
                  (2010). Isoeugenol monooxygenase and its putative regulatory
                  gene are located in the eugenol metabolic gene cluster in
                  Pseudomonas nitroreducens Jin1. Archives of microbiology,
                  192(3), 201–209. https://doi.org/10.1007/s00203-010-0547-y
                </p>
              </ModalGlass>

              <h1 className="text-3xl text-white font-bold ">LACCASE FOR</h1>
              <h1 className="text-6xl text-white font-bold">
                DEGRADATION SYSTEM
              </h1>
            </div>
            <p className="text-white m-20 border-2 rounded-md text-3xl">
              iGEM TecCEM 2022 Team designed this composite part with coding
              sequence for Laccase from Trametes versicolor, making a
              contribution to the part registered by iGEM12_UCL_London,
              BBa_K729002 , even though that laccase was analyzed to degrade
              polyethylene, but due to being capable of degrading phenolic
              compounds, it is of interest for degrading Endocrine Chemical
              Disruptors, the problematic set for this year competition by our
              team, we aim to oxidize EDCs such as BPA into less aggressive,
              photosensitive removable compounds [1][2]. The chosen biobrick has
              good characterization provided by other teams. Laccase from white
              rot fungi Trametes versicolor with signal peptide OmpA [3] [4] and
              histidine tag (Protein coding) for endocrine disruptor chemicals
              in wastewater is a composite part built to produce laccase in the
              periplasmic space of E.Coli in where proteins are better
              solubilized. The laccase from Trametes Versicolor was chosen
              because its wide range of substrates and its ability to carry out
              its redox reaction in the absence of hydrogen peroxide [1][2].
              Amino acids were optimized for E.Coli as biofabric, because the
              original sequence comes from Trametes Versicolor. We added both a
              promoter and a terminator sequence to the construct in order to
              allow protein expression using a cloning and expression plasmid
              for bacterial transformation.
            </p>

            <p className="text-white m-20 border-2 rounded-md text-3xl">
              BBa_K4260003: Laccase Trametes Versicolor coding cassette with T7
              expression system, OmpA signal peptide and histidine tag
              <br />
              <br /> T7 promoter BBa_J64997
              <br />
              Lac-operator BBa_K1624002Intein
              <br />
              OmpA_signal peptide [3][4]
              <br /> Laccase for polyethylene degradation BBa_K729002
              <br /> Histidine tag [5]
              <br /> Terminador T7 BBa_K395601
              <br />
              See our in vitro assembly at parts.
            </p>

            <label htmlFor="degradationRef">
              <h1 className="text-3xl text-white font-bold text-center">
                {" "}
                References (Click me!)
              </h1>
            </label>

            <ModalGlass modalId="degradationRef">
              <p className="text-white m-20 border-2 rounded-md text-3xl">
                [1] Goulas T, Cuppari A, Garcia-Castellanos R, Snipas S,
                Glockshuber R, Arolas JL, et al. (2014) The pCri System: A
                Vector Collection for Recombinant Protein Expression and
                Purification. PLoS ONE 9(11):
                e112643.https://doi.org/10.1371/journal.pone.0112643 [2]
                http://parts.igem.org/Part:BBa_K208003 [3] Klein, J., Jiang, S.,
                Galimidi, R. P., Keeffe, J. R., & Bjorkman, P. J. (2014,
                October). Design and characterization of structured protein
                linkers with differing flexibilities. Protein Engineering,
                Design and Selection, 27(Issue 10), 325–330.
                https://doi.org/10.1093/protein/gzu043 [4] TecCEM 2021
                https://2021.igem.org/Team:TecCEM [5] Paterni, I., Granchi, C.,
                Katzenellenbogen, J. A., & Minutolo, F. (2014). Estrogen
                receptors alpha (ERα) and beta (ERβ): subtype-selective ligands
                and clinical potential. Steroids, 90, 13–29.
                https://doi.org/10.1016/j.steroids.2014.06.012 [6] IBA Solutions
                for life sciences. (2021, August). Expression and purification
                of proteins using 6xHistidine-tag. IBA.
                https://www.iba-lifesciences.com/media/a8/ee/aa/1631860506/Manual-6xHistidine-tag.pdf
              </p>
            </ModalGlass>

            <h1 className="text-6xl text-white font-bold">SAFETY PROJECT</h1>
            <p className="text-white m-20 border-2 rounded-md text-3xl">
              It is well known that antibiotics are necessary in synthetic
              biology experimental procedures. Therefore iGEM TecCEM designed 2
              coding sequences for the replacement of tradicional selection
              markers, antibiotics; being our main focus the most commonly used
              microorganism Escherichia coli; in order to prevent more serious
              problems in the future due to antibiotic-resistant microorganisms.
              These sequence encodes the gene of Isoeugenol Monooxygenase
              (IsoMo), that allows bacteria to direct the enzyme to the
              periplasm with pelB signal sequence. With IsoMo we aim to confer
              bacteria the ability to resist isoeugenol, an inhibitory agent
              added to culture mediums, and directly converts to vanillin. The
              coding sequence we use comes from Pseudomonas putida IE27,
              reported by Yamada, Okada, Yoshida & Nagasawa in 2008. [6] For the
              design of the selection marker, two genetic constructs were made:
              one directly inducible by isoeugenol (Pp_22) and other regulated
              by a constitutive promoter (Nc_22); this, in order to test the
              efficiency of the two systems.
            </p>

            <p className="text-white m-20 border-2 rounded-md text-3xl">
              <em style={{ color: "Yellow" }}>
                Best New Composite Part BBa_K4260006 (Nc_22) (composite parts)
              </em>
              <br /> ESR1 mRNA sequence [5] <br /> rrnBT1 BBa_B0010 [1] <br />{" "}
              Constitutive promoter BBa_J23100 [2]
              <br /> RBS+pelB+IsoMo BBa_J23100 [3]
              <br /> BBa_K4260011 (RBS+pelB+IsoMo) (coding sequence) RBS
              BBa_B0030 [4] <br /> pelB BBa_J32015 [5] <br /> IsoMo [6] <br />{" "}
              BBa_K4260006 (Pp_22) (composite parts)
              <br />
              rrnBT1 BBa_B0010 [1]
              <br /> Trp terminator BBa_K4260008 [7]
              <br />
              RBS+pelB+IsoMo BBa_K4260009 [8]
              <br /> BBa_K4260009 (IemR+Promoter+pelB+IsoMo) (coding sequence)
              <br />
              IemR [9]
              <br /> Promoter [9]
              <br />
              pelB BBa_J32015 [5]
              <br /> IsoMo [6]
              <br /> See our in vitro assembly at parts.
            </p>
            <label htmlFor="safetyRef">
              <h1 className="text-3xl text-white font-bold text-center">
                {" "}
                References (Click me!)
              </h1>
            </label>
            <ModalGlass modalId="safetyRef">
              <p className="text-white m-20 border-2 rounded-md text-3xl">
                [1] http://parts.igem.org/Part:BBa_B0010 [2]
                http://parts.igem.org/Part:BBa_J23100 [3] *link regestry [4]
                http://parts.igem.org/Part:BBa_B0030 [5]
                http://parts.igem.org/Part:BBa_J32015 [6] Yamada, M., Okada, Y.,
                Yoshida, T., & Nagasawa, T. (2007). Purification,
                characterization and gene cloning of isoeugenol-degrading enzyme
                from Pseudomonas putida IE27. Archives of microbiology, 187(6),
                511–517. https://doi.org/10.1007/s00203-007-0218-9 [7] *link
                regestry [8] *link regestry [9] Ryu, J. Y., Seo, J., Unno, T.,
                Ahn, J. H., Yan, T., Sadowsky, M. J., & Hur, H. G. (2010).
                Isoeugenol monooxygenase and its putative regulatory gene are
                located in the eugenol metabolic gene cluster in Pseudomonas
                nitroreducens Jin1. Archives of microbiology, 192(3), 201–209.
                https://doi.org/10.1007/s00203-010-0547-y
              </p>
            </ModalGlass>
          </div>
        </div>
      </div>
    </div>
  );
}
